import {
  getCampusRecruitments,
  getCampusRecruitmentById,
  getOrientationsById,
  getExpoById
} from '~api/campus-recruiting'

export const state = () => ({
  recruitments: [],
  pages: {},
  currentRecruitment: {},
  currentOrientationDetails: [],
  currentExpoDetails: {},
  currentAdvertisements: [],
  currentExpoInfo: {},
  currentOrientationInfo: {}
})

export const getters = {
  recruitmentsGetter: state => state.recruitments,
  pageGetter: state => state.pages,
  currentRecruitmentGetter: state => state.currentRecruitment,
  currentAdvertisementsGetter: state => state.currentAdvertisements,
  currentExpoInfoGetter: state => state.currentExpoInfo,
  currentOrientationInfoGetter: state => state.currentOrientationInfo,
  currentOrientationDetailsGetter: state => state.currentOrientationDetails,
  currentExpoDetailsGetter: state => state.currentExpoDetails,
  nthBoothGetter: state => (n) => {
    if (
      Object.keys(state.currentExpoDetails).includes('expo_booths') &&
      Object.keys(state.currentExpoDetails.expo_booths).includes(`${n}`)
    ) {
      return state.currentExpoDetails.expo_booths[`${n}`].booth_company_name
    }
    return ''
  }
}

export const actions = {
  async getAllRecruitments ({ commit }, params) {
    const response = await getCampusRecruitments(params)
    const {
      recruitments,
      pages
    } = response

    commit('setRecruitments', recruitments)
    commit('setRecruitmentsPage', pages)

    return response
  },
  async getRecruitmentDetailsById ({
    commit
  }, id) {
    const recruitment = await getCampusRecruitmentById(id)
    const {
      basicInfo,
      advertisements,
      orientationInfo,
      expoInfo
    } = recruitment
    commit('setCurrentRecruitment', basicInfo)
    commit('setCurrentAdvertisements', advertisements)
    commit('setCurrentOrientationInfo', orientationInfo)
    commit('setCurrentExpoInfo', expoInfo)
    return recruitment
  },
  async getOrientationsDetailsById ({
    commit
  }, id) {
    const orientations = await getOrientationsById(id)
    commit('setCurrentOrientationDetails', orientations)
    return orientations
  },
  async getExpoDetailsById ({
    commit
  }, data) {
    const response = await getExpoById(data)
    const {
      expo,
      pages
    } = response
    if (!data.page) {
      commit('setCurrentExpoDetails', expo)
    } else {
      commit('setCurrentPageExpoList', expo.expo_booths)
    }

    commit('setCurrentExpoDetailsPage', pages)
    return expo
  }
}
export const mutations = {
  setRecruitments (state, payload) {
    state.recruitments = payload
  },
  setRecruitmentsPage (state, payload) {
    state.pages = payload
  },
  setCurrentExpoDetailsPage (state, payload) {
    state.pages = payload
  },
  setCurrentRecruitment (state, payload) {
    state.currentRecruitment = payload
  },
  setCurrentOrientationDetails (state, payload) {
    state.currentOrientationDetails = payload
  },
  setCurrentExpoDetails (state, payload) {
    state.currentExpoDetails = payload
  },
  setCurrentPageExpoList (state, payload) {
    state.currentExpoDetails.expo_booths = Object.assign({}, payload)
  },
  setCurrentAdvertisements (state, payload) {
    state.currentAdvertisements = payload
  },
  setCurrentOrientationInfo (state, payload) {
    state.currentOrientationInfo = payload
  },
  setCurrentExpoInfo (state, payload) {
    state.currentExpoInfo = payload
  }
}
